export interface IOrderManagementProps {
    
}
export interface IOrderManagementImageProps {
    value:any;
    data:any;
}

export interface IOrderManagementCancelOrderProps {
    text:string;
    value:any;
}

export interface IOrderManagementAssignDeliveryProps {
    text:string;
    value:any;
}

export interface IOrderManagementOrderReturnProps {
    text:string;
    value:any;
}

export interface IOrderManagementPaginationProps {
    
}

export interface ISearchComponent {
  inputError: boolean;
  handleKeyPress: (e: any) => void;
  handleInputSearch: (e: any) => void;
  handleSearch: () => void;
  setShowClearButton: React.Dispatch<React.SetStateAction<boolean>>;
  handleClear: () => void;
  showClearButton: boolean;
  searchText: string;
  setSearchText: React.Dispatch<React.SetStateAction<string>>;
}

export interface OrderDetails {}

export interface IPetDetailsForm {
  pet_name: string;
  pet_gender: string;
  pet_specie: string;
  pet_dob: string;
  pet_tempeture: string;
  pet_weight: string;
}

export interface IMedicalSummaryForm {
  concern_and_symptoms: string;
  ongoing_medication: string;
}

export interface ITaperingDoseRow {
  dose?: string;
  dose_unit?: string;
  frequency?: string;
  timing?: string;
  duration?: string;
  duration_unit?: string;
  remark?: string;
  quantity?: string | number;
}

export interface IEditableMedicineRow {
  item_name?: string;
  name?: string;
  prescription_type?: string;
  dose?: string;
  dose_unit?: string;
  frequency?: string;
  timing?: string;
  duration?: string;
  duration_unit?: string;
  remark?: string;
  remarks?: string;
  quantity?: string | number;
  tapering_doses?: ITaperingDoseRow[];
}

export type AutoSaveSection =
  | "pet_details"
  | "concern_and_symptoms"
  | "ongoing_medication"
  | "medicines"
  | "medicines_instructions";

export const displayValue = (value?: string | number | null) => {
  if (value === null || value === undefined || value === "") return "--";
  return String(value);
};

export const createEmptyTaperingDose = (): ITaperingDoseRow => ({
  dose: "",
  dose_unit: "",
  frequency: "",
  timing: "",
  duration: "",
  duration_unit: "",
  remark: "",
  quantity: "",
});
